import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import * as feather from 'feather-icons';
import { LayoutService } from '../../../services/layout.service';
import { NavService } from '../../../services/nav.service';
import { fadeInAnimation } from '../../../data/router-animation/router-animation';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  animations: [fadeInAnimation]
})
export class ContentComponent implements OnInit, AfterViewInit {

  isShowSidebar: boolean = true;
  fadeInAnimationState: string = ''; 
  isInventoryModule: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public navServices: NavService,
    public layout: LayoutService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.updateLayoutForUrl(this.router.url);

    router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.urlAfterRedirects || event.url;

        // Check if we're in inventory module
        this.isInventoryModule = currentUrl.includes('/inventory');
        this.isShowSidebar = !this.isShelllessRoute(currentUrl);

        // Handle animation
        setTimeout(() => {
          this.fadeInAnimationState = currentUrl;
          this.cdr.detectChanges();
        });
      }
    });

    // this.route.queryParams.subscribe((params) => {
    //   console.log('params', params)
    //   if (params) {

    //   }
    //   // this.layout.config.settings.layout = params.layout ? params.layout : this.layout.config.settings.layout
    // })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      feather.replace();
    });

    this.cdr.detectChanges();
  }

  public getRouterOutletState(outlet) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  private normalizeUrl(url: string): string {
    return (url || '').split('?')[0].split('#')[0];
  }

  private isShelllessRoute(url: string): boolean {
    const normalizedUrl = this.normalizeUrl(url);
    return normalizedUrl === '/auth/login' || normalizedUrl === '/new-dashboard';
  }

  private updateLayoutForUrl(url: string): void {
    const normalizedUrl = this.normalizeUrl(url);
    this.isInventoryModule = normalizedUrl.includes('/inventory');
    this.isShowSidebar = !this.isShelllessRoute(normalizedUrl);
  }

  get layoutClass() {
    switch (this.layout.config.settings.layout) {
      case "Dubai":
        return "compact-wrapper"
      case "London":
        return "only-body"
      case "Seoul":
        return "compact-wrapper modern-type"
      case "LosAngeles":
        return this.navServices.horizontal ? "horizontal-wrapper material-type" : "compact-wrapper material-type"
      case "Paris":
        return "compact-wrapper dark-sidebar"
      case "Tokyo":
        return "compact-sidebar"
      case "Madrid":
        return "compact-wrapper color-sidebar"
      case "Moscow":
        return "compact-sidebar compact-small"
      case "NewYork":
        return "compact-wrapper box-layout"
      case "Singapore":
        return this.navServices.horizontal ? "horizontal-wrapper enterprice-type" : "compact-wrapper enterprice-type"
      case "Rome":
        return "compact-sidebar compact-small material-icon"
      case "Barcelona":
        return this.navServices.horizontal ? "horizontal-wrapper enterprice-type advance-layout" : "compact-wrapper enterprice-type advance-layout"
      case "horizontal-wrapper":
        return this.navServices.horizontal ? "horizontal-wrapper" : "compact-wrapper"
      default:
        return "compact-wrapper"
    }
  }

  ngOnInit() {

  }

}
